import React from 'react';

import { Stack, Typography } from '@mui/material';

import { sharedClasses } from './sharedClasses';

import type { CSSProperties, ReactNode } from 'react';

interface IEmptyStateProps {
  svgIcon: ReactNode;
  label: string;
  textSx?: CSSProperties;
  wrapperSx?: CSSProperties;
}

export const EmptyState = ({ svgIcon, label, wrapperSx, textSx }: IEmptyStateProps) => (
  <Stack sx={{ padding: 7.5, alignItems: 'center', rowGap: 2, ...(wrapperSx ?? {}) }}>
    {svgIcon}
    <Typography sx={{ ...sharedClasses.emptyStateText, ...(textSx ?? {}) }}>{label}</Typography>
  </Stack>
);
